import * as api from "../Services/api.js";

export const state = {
  schoolId: 0,
};
export const mutations = {
  SET_SCHOOL_ID(state, payload) {
    state.schoolId = payload;
  },
};
export const getters = {};
export const actions = {
  async sendFeedbackEmail({ commit, state }, payload) {
    commit("uxModule/setShowLoader", true, { root: true });
    commit("uxModule/setShowSnackbar", false, { root: true });
    api.sendFeedbackEmail(payload.feedbackParams).then((response) => {
      commit("uxModule/setShowLoader", false, { root: true });
      if (response.data.success) {
        var msg = response.data.message;
        commit("uxModule/setSnackbarMsg", msg, {
          root: true,
        });
      } else {
        var msg = "Your feedback email was not sent. " + response.data.message;
        commit("uxModule/setSnackbarMsg", msg, {
          root: true,
        });
      }
      commit("uxModule/setShowSnackbar", true, { root: true });
    });
  },
  async getSchoolId({ state, commit, rootState }) {
    let legacySystemId = rootState.securityModule.userProfile.legacySystemId;

    return await api
      .getQuery("/school/getSchoolId", {
        legacySchoolId: legacySystemId,
      })
      .then((response) => {
        if (response.success) {
          commit("SET_SCHOOL_ID", response.data);
        }

        return state.schoolId;
      })
      .catch((error) => {
        return false;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
